import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthTokenService } from '@ui-core/services/auth-token.service'
import { catchError, from, switchMap, throwError } from 'rxjs'

const AUTH_RETRY_ATTEMPTED = new HttpContextToken<boolean>(() => false)

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
    const authTokenService = inject(AuthTokenService)

    return from(authTokenService.getValidToken()).pipe(
        switchMap((token) => {
            const request = token
                ? req.clone({
                      setHeaders: { Authorization: `Bearer ${token}` },
                  })
                : req

            return next(request)
        }),
        catchError((error) => {
            if (
                error instanceof HttpErrorResponse &&
                (error.status === 401 || error.status === 403) &&
                !req.context.get(AUTH_RETRY_ATTEMPTED)
            ) {
                return from(authTokenService.getValidToken({ forceRefresh: true })).pipe(
                    switchMap((token) => {
                        if (!token) {
                            return throwError(() => error)
                        }

                        const retryReq = req.clone({
                            context: req.context.set(AUTH_RETRY_ATTEMPTED, true),
                            setHeaders: { Authorization: `Bearer ${token}` },
                        })

                        return next(retryReq)
                    }),
                    catchError(() => throwError(() => error))
                )
            }

            return throwError(() => error)
        })
    )
}
